import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=44e6e6a8&"
import script from "./Keywords.vue?vue&type=script&lang=js&"
export * from "./Keywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e6e6a8')) {
      api.createRecord('44e6e6a8', component.options)
    } else {
      api.reload('44e6e6a8', component.options)
    }
    module.hot.accept("./Keywords.vue?vue&type=template&id=44e6e6a8&", function () {
      api.rerender('44e6e6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/Keywords.vue"
export default component.exports